import { combineReducers } from '@reduxjs/toolkit';

import offeringReducer from './offering/slice';
import searchReducer from './search/slice';
import userReducer from './user/slice';
import partnerVerificationReducer from './partnerVerification/slice';

const rootReducer = combineReducers({
  user: userReducer,
  search: searchReducer,
  offering: offeringReducer,
  partnerVerification: partnerVerificationReducer,
});

export default rootReducer;
